import { Ribbon } from "GameObjects/StoryGame/ch6/Ribbon";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p05 } from "../../../layouts/ch6_p05/ch6_p05";

export class Chapter6Page5 extends AbstractStoryState implements ReturnType<typeof ch6_p05> {

    readonly bg = this.addChild(new SceneSprite());
    readonly giftContainer = this.addChild(new PIXI.Container());
    readonly gift = list(()=>this.giftContainer.addChildAt(new SceneSprite(), 0));
    readonly bow = list(()=>this.giftContainer.addChild(new SceneSprite()));

    readonly ribbonRightEndPos = this.giftContainer.addChild(new SceneSprite());
    readonly ribbonLeftEndPos = this.giftContainer.addChild(new SceneSprite());
    readonly ribbonRight = this.giftContainer.addChild(new Ribbon());
    readonly ribbonLeft = this.giftContainer.addChild(new Ribbon());

    readonly ribbonLeftMask = [];
    readonly ribbonRightMask = [];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p05/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p05/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p05.call(this);
        this.frameLeft.visible = false;
        this.frameRight.visible = false;

        this.gift.forEach(g=>g.visible = false);
        this.gift[0].visible = true;

        this.bow.forEach(r=>r.visible = false);
        this.bow[0].visible = true;

        this.ribbonLeft.visuals.mask = this.addChild(new PIXI.Graphics()).beginFill(0xff0000).drawPolygon(this.ribbonLeftMask).endFill();
        this.ribbonRight.visuals.mask = this.addChild(new PIXI.Graphics()).beginFill(0xff0000).drawPolygon(this.ribbonRightMask).endFill();

        this.ribbonLeft.setEndPoint(this.ribbonLeftEndPos.position);
        this.ribbonRight.setEndPoint(this.ribbonRightEndPos.position);

        this._subscriptions.push(PubSub.subscribe("ribbon progress", this.onRibbonProgress.bind(this)));
        this._subscriptions.push(PubSub.subscribe("ribbon complete", this.onRibbonComplete.bind(this)));

        this.ribbonLeftEndPos.visible = false;
        this.ribbonRightEndPos.visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();

    }

    protected onRibbonComplete(pTopic: "ribbon complete", pData: {target: Ribbon, progress: number}) {
        this.ribbonLeft.interactive = false;
        this.ribbonRight.interactive = false;

        new TimelineLite()
            .call(()=>{
                TweenLite.to([this.ribbonLeft, this.ribbonRight], 1, {pixi: {alpha: 0}});
                this.bow[2].FadeOut();
            }, undefined, undefined, 0)
            .call(()=>{
                this.gift[0].FadeOut();
                this.gift[1].FadeIn();
            }, undefined, undefined, 1)
            .call(()=>{
                this.gift[1].FadeOut();
                this.gift[2].FadeIn();
            }, undefined, undefined, 2)
            .call(()=>{
                this.gift[2].FadeOut();
                this.gift[3].FadeIn();
            }, undefined, undefined, 3)
            .call(()=>{
                this.gotoNextState({transition: "left"});
            }, undefined, undefined, 4)

    }

    protected onRibbonProgress(pTopic: "ribbon progress", pData: {target: Ribbon, progress: number}) {

        // mirror drags
        switch (pData.target) {
            case this.ribbonLeft:
                this.ribbonRight.setProgress(pData.progress);
                break;
            case this.ribbonRight:
                this.ribbonLeft.setProgress(pData.progress);
                break;
        }

        // bow sprite swap
        if (pData.progress > 0.75) {
            this.bow[2].visible = true;
            this.bow[1].visible = false;
            this.bow[0].visible = false;
        }
        else if (pData.progress < 0.25) {
            this.bow[2].visible = false;
            this.bow[1].visible = false;
            this.bow[0].visible = true;
        }
        else {
            this.bow[2].visible = false;
            this.bow[1].visible = true;
            this.bow[0].visible = false;
        }
    }
}